/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationCustomersGetCreatedCreatedCustomerBySalesRepresentativeResponse { 
    salesRepresentativeId?: string | null;
    salesRepresentativeName?: string | null;
    total?: number;
    userId?: string | null;
    employerColor?: string | null;
    employerName?: string | null;
}

